import React from 'react'
import './App.css'
import MainPage from './MainPage'

const App = () => {
  return (
    <>
      <MainPage />
    </>
  )
}

export default App